export default {
  inject: {
    formGroup: {
      default: null,
    },
  },
  props: {
    id: {
      type: String,
      required: false,
      default: null,
    },
  },
  computed: {
    safeId() {
      return (
        (this.formGroup && this.safeId) ||
        this.id ||
        `form-${Math.ceil(Math.random() * 100000000000)}`
      );
    },
  },
};
